import * as React from "react";
import PropTypes from "prop-types";
import { History, Location, Action as HistoryAction, UnregisterCallback } from "history";
import { parse } from "qs";

import { RouteInfo } from "../../../lib/routing";
import { router } from "../../../routes";
import Renderer from "./Renderer";

interface Props {
  history: History;
  defaultRouteInfo: RouteInfo<any>;
}

interface State {
  routeInfo: RouteInfo<any> | null;
}

class Router extends React.Component<Props, State> {
  public static childContextTypes = {
    history: PropTypes.object.isRequired,
  };

  private unregister: UnregisterCallback = undefined!;

  constructor(props: Props) {
    super(props);

    this.state = { routeInfo: null };
  }

  public getChildContext() {
    return {
      history: this.props.history,
    };
  }

  public componentDidMount() {
    this.unregister = this.props.history.listen(this.onLocationChange);
  }

  public componentWillUnmount() {
    this.unregister();
  }

  public onLocationChange = (location: Location, _action?: HistoryAction) => {
    router
      .resolve({
        pathname: location.pathname,
        hash: location.hash,
        query: parse(location.search, { ignoreQueryPrefix: true }),
      })
      .then(routeInfo => {
        this.setState({ routeInfo });
        (window as any).ga("send", "pageview", document.location.href);
      });
  };

  public render() {
    const routeInfo = this.state.routeInfo || this.props.defaultRouteInfo;
    if (routeInfo) {
      return <Renderer routeInfo={routeInfo} />;
    } else {
      return null;
    }
  }
}

export default Router;



// WEBPACK FOOTER //
// ./frontend/src/common/components/router/Router.tsx